// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityCopay {
    'appliesToOop'?: string;
    'waivedAfterOop'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityCopay>> = [
        {
            "name":     "appliesToOop",
            "baseName": "appliesToOop",
            "type":     "string"
        },
        {
            "name":     "waivedAfterOop",
            "baseName": "waivedAfterOop",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityCopay.attributeTypeMap;
    }
}
